// Converted from application/views/sculptures/mother&child-story_v.php. Edit this component directly.
export default function SculpturesMotherChildStoryPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/Emily-feeding-Coco-Blossom.jpg"} alt={"Emily Feeding Coco Blossom"} />
<figcaption>{"Emily Feeding Coco Blossom"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Mother & Child"}</h1>
<h2>{"\n                    A Secret Hidden In Stone\n                "}</h2>
</div>
<p>{"\n                In January 2005, I travelled to London with my daughter Kelly to visit her childhood friend Emily, who was nursing her new-born daughter, Coco Blossom.\n            "}</p>
<p>{"\n                We chatted as she sat on the sofa in lotus position holding the baby lovingly at her breast.\n            "}</p>
<p>{"\n                Many artists before me have been inspired to recreate a moment of maternal love from their childhood.\n            "}</p>
<p>{"\n                This was the moment when the sculpture of “Mother and Child” was conceived in my mind.\n            "}</p>
<p>{"\n                “Emily, would you pose for me in that position?”\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/transparent-marble.jpg"} alt={"A fragment of carrara Marble"} />
<figcaption>{"A fragment of carrara Marble"}</figcaption>
</figure>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Emily agreed, and we began to make arrangements for her to bring Coco to Dublin to sit for a lifesize sculpture.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/the-wax-torso-begins-to-take-form.jpg"} alt={"The wax torso of “Mother” begins to take form as Paddy Campbell starts work at his Fairview studio in Dublin"} />
<figcaption>{"The wax torso of “Mother” begins to take form as Paddy Campbell starts work at his Fairview studio in Dublin"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/Paddy-campbell-with-child-and-wax-form.jpg"} alt={"Paddy Campbell with Coco Blossom while the wax form of “Mother and Child” was being modelled at Fairview"} />
<figcaption>{"Paddy Campbell with Coco Blossom while the wax form of “Mother and Child” was being modelled at Fairview"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                It was the beginning of a 17-year odyssey at the end of which baby Coco had grown into a beautiful young woman, and Emily had established a career teaching Yoga and Wellness in Margate on the South Coast of England.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                I formed the figures of Emily and her child, using ivory coloured modelling wax, over a six-week period, which the three of us spent together, in February / March 2005.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/wax-statue-work-in-progress.jpg"} alt={"Work in progress in wax, with Emily and Coco in background"} />
<figcaption>{"Work in progress in wax, with Emily and Coco in background"}</figcaption>
</figure>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/baby-statue-in-wax.jpg"} alt={"Paddy Campbell making the “baby“ Coco in wax while Emily took a break"} />
<figcaption>{"Paddy Campbell making the “baby“ Coco in wax while Emily took a break"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/adding-wax-to-statue.jpg"} alt={"Adding wax, “like words in a poem, every piece should mean something”"} />
<figcaption>{"Adding wax, “like words in a poem, every piece should mean something”"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                In those winter days my cluttered studio in Fairview looked out on the sleepy river Tolka in Dublin, and it seemed to fill with bright sunshine and pale shadows, as I bent the aluminium armature into shape, and added wax, piece by piece – like words in a poem – finding a rhythm which became more and more like that of my two subjects.\n            "}</p>
<p>{"\n                By the time I was finished, one problem which I encountered was that the six-week old Coco had grown into a three month old, which meant that the wax “child” needed to evolve as I worked.\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/statue-wip-from-behind.jpg"} alt={"Work in progress, viewed from behind"} />
<figcaption>{"Work in progress, viewed from behind"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/baby-played.jpg"} alt={"“Coco played, peed, slept, and fed at her mother’s breast”"} />
<figcaption>{"“Coco played, peed, slept, and fed at her mother’s breast”"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                As each day passed in harmony, I felt drawn into moments of intimacy while Coco played, peed, slept, and fed at her mother’s breast.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n            One day as I watched entranced, Emily stroked Coco’s head tenderly.  The love in that simple gesture was so immense, so powerful, that this sculpture could not have been made in any other way.  I asked Emily to hold her hand in that position, barely touching the baby’s head, so that I could capture that moment in sculpture.  At such times I shared the joy of Mother and Child, together with my two live models.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/Emily-strokes-baby-head.jpg"} alt={"Emily strokes Coco’s head"} />
<figcaption>{"Emily strokes Coco’s head"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/statue-finished-or-not.jpg"} alt={"Decision time - finished or not?"} />
<figcaption>{"Decision time - finished or not?"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                One of the most difficult calls for an artist to make is to decide when a sculpture (or painting) is finished.  As the wax sculpture of Mother and Child was being carted down the narrow staircase in Fairview to be brought to the foundry, I knew that I had to let go.  I could already feel withdrawal symptoms as I bade farewell to Emily and Coco Blossom at Dublin Airport.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Paddy Campbell with the finished wax sculpture of “Mother and Child“\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/finished-wax-sculpture.jpg"} alt={"Paddy Campbell with the finished wax sculpture of "} />
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/Baby-meets-mother.jpg"} alt={"One year old Coco visits her new-born bronze self at palazzo Corsini, Florence in 2006"} />
<figcaption>{"One year old Coco visits her new-born bronze self at palazzo Corsini, Florence in 2006"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                Mother and Child was first cast in bronze at the South Brown Street foundry in Dublin in the summer of 2005.  It was first exhibited at Palazzo Corsini in Florence the following year, where Emily and Coco came for their first viewing of the finished piece.  Coco, then just one-year old was suitably amused by her erstwhile infant form.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                The bronze “Mother and Child” later featured at Exhibitions in Dublin, Cork, Belfast, Fiesole, Florence, Vicchio, Positano, and San Giovanni Valderno, between 2007 and 2015.\n            "}</p>
<p>{"\n                While all this was happening, I often reflected on my own mother’s role as a midwife in Ireland during World War II.  She would have been intrigued by my role as a kind of “Sculptural Midwife”.  This culminated in the donation of my bronze sculpture of “Mother and Child” to the Rotunda Maternity Hospital in Dublin in 2008, where my mother had trained as a nurse before I was born.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/paddy-with-bronze-sculpture.jpg"} alt={"Paddy Campbell with the Bronze sculpture of Mother and Child in exhibition at Palazzo Corsini"} />
<figcaption>{"Paddy Campbell with the Bronze sculpture of Mother and Child in exhibition at Palazzo Corsini"}</figcaption>
</figure>
</div>
<div class={"container"}>
<div class={"text"}>
<div>
<p>{"\n                By 2013 I was spending most of my time at my studio in Via Luna, Florence preparing for the exhibition at Palazzo Medici Riccardi entitled “Di Cuore” (From the Heart).  All around me in Florence, the cradle of sculpture, were marble masterpieces by Michelanglo, Bernini, Giambologna, Canova and Cellini.  The dream of a “Mother and Child” in marble, was playing on my mind.\n            "}</p>
<p>{"\n                One day I paid a visit to my good friend Dario Tazzioli, at his atelier in Frassinoro, in the Appenine mountains close to Cararra.  Dario was, and is, one of the most extraordinary and accomplished artists and carvers in Italy.  He was well acquainted with “Mother and Child” in bronze and he understood the importance of selecting a piece of Cararra marble which contained the right combination of strength (for limbs) and purity (for the face).\n            "}</p>
<p>{"\n                Before I left for Florence next morning Dario and myself had agreed to collaborate in the production of a marble version of “Mother and Child”.  I was to provide the original sculptural form and attend when necessary to provide advice and guidance.  Dario would select the marble in the caves at Cararra, and carve a likeness of my original, which I provided in gesso, sitting on a soft cushion.\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/Dario-working-on-sculpture.jpg"} alt={"Dario demonstrates his techniques during work-in-progress at the “Di Cuore” Exhibition at Palazzo Medici Riccardi in 2013"} />
<figcaption>{"Dario demonstrates his techniques during work-in-progress at the “Di Cuore” Exhibition at Palazzo Medici Riccardi in 2013"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                By the time my “Di Cuore” Exhibition had opened, Dario had already begun to work on the “Mother and Child” in marble, at his Atelier in Frassinoro.\n            "}</p>
<p>{"\n                He brought the unfinished marble to Palazzo Medici Riccardi during the exhibition and continued to carve it, demonstrating his techniques to fascinated visitors from all over the world.\n            "}</p>
<p>{"\n                I was fortunate that my good friend Agatino Vacante, an excellent photographer, was able to join me in both in Palazzo Medici Riccardi, and at Dario’s atelier in Fassinoro, to take most of the wonderful photos which feature on these pages.\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/dario-tools.jpg"} alt={"Dario’s tools, similar to those used in Renaissance times "} />
<figcaption>{"Dario’s tools, similar to those used in Renaissance times "}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                As he always did, Dario worked diligently by hand, using tools and instruments which he had made in his own forge, and which were similar to those in use at the time of the Renaissance.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                He checked for accuracy using traditional measuring methods, and he avoided using modern computer technology which he felt would “deaden” the effect.\n            "}</p>

</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/match-equipment.jpg"} alt={"Equipment used by Dario to ensure marble version (in background) exactly matched the gesso copy of the wax original"} />
<figcaption>{"Equipment used by Dario to ensure marble version (in background) exactly matched the gesso copy of the wax original"}</figcaption>
</figure>
</div>
<div class={"container photoRight"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/potrey-in-sculpture.jpg"} alt={"The potrey of form in marble."} />
<figcaption>{"The poetry of form in marble."}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                The poetry of form in marble.\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/dario-violin.jpg"} alt={"Dario using a “violin” to drill delicately behind the marble"} />
<figcaption>{"Dario using a “violin” to drill delicately behind the marble"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                Dario explained to me that the “violin” was used by Renaissance sculptors, including Michelangelo, before ever any mechanical means were devised to carry out this delicate task."}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/chiselling-delicate-patterns.jpg"} alt={"Paddy observes Dario chiselling the delicate patterns on the cushion"} />
<figcaption>{"Paddy observes Dario chiselling the delicate patterns on the cushion"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                As he carved the pillow, I was in awe of his sublime skills, etching intricate “brocade” patterns on the surface, and adding tassels along the underside.  The pillow now became a “magic-carpet” to carry the pair, as if on a cloud…\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                When he had finished this marble sculpture of Mother and Child I was so pleased with Dario’s work that I asked him to inscribe both our names on a panel at the side of the pillow.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/Dario-inscribed.jpg"} alt={"“Dario Tazzioli” inscribed on the pillow to acknowledge his sublime skill as a carver of marble"} />
<figcaption>{"“Dario Tazzioli” inscribed on the pillow to acknowledge his sublime skill as a carver of marble"}</figcaption>
</figure>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/baby-feet-sculpture.jpg"} alt={"Baby feet denote contentment"} />
<figcaption>{"Baby feet denote contentment"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                Baby feet denote contentment\n            "}</p>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/express-love.jpeg"} alt={"Mother and baby hands express the love between them"} />
<figcaption>{"Mother and baby hands express the love between them"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                I remember watching silently as the marble was encased in a solid wooden crate which Dario had crafted specially to protect it from damage in transit or in storage.  That sad feeling of having to “let go” tinged my heart again.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                I had yet to find a place where “Mother and Child” could finally settle, to be appreciated and cared for as I felt it deserved.\n            "}</p>
<p>{"\n                It was three more years before that crate was to be opened again.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/sculpture-nearly-finished.jpg"} alt={"“Mother and Child” in Cararra Marble, nears completion at Atelier Dario Tazzioli in Frassinoro in 2015"} />
<figcaption>{"“Mother and Child” in Cararra Marble, nears completion at Atelier Dario Tazzioli in Frassinoro in 2015"}</figcaption>
</figure>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/finished-sculpture-in-frassinoro.jpg"} alt={"Finished marble of Mother and Child at Dario’s Atelier in Frassinoro in 2015"} />
<figcaption>{"Finished marble of Mother and Child at Dario’s Atelier in Frassinoro in 2015"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                Finished marble of Mother and Child at Dario’s Atelier in Frassinoro in 2015\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/sculpture-in-pietrasanta.jpg"} alt={"Il Dolce Rumore Della Vita Exhibition opening Pietrasanta in 2018"} />
<figcaption>{"Il Dolce Rumore Della Vita Exhibition opening Pietrasanta in 2018"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                The next time “Mother and Child” was to be seen again was in Pietrasanta, in the Autumn of 2018, during an exhibition entitled “Il Dolce Rumore Della Vita” (The Sweet Sound of Life).\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/emily-and-coco-visiting.jpg"} alt={"Coco and Emily visit the exhibition in the ancient cathedral in Pietrasanta"} />
<figcaption>{"Coco and Emily visit the exhibition in the ancient cathedral in Pietrasanta"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                The next time “Mother and Child” was to be seen again was in Pietrasanta, in the Autumn of 2018, during an exhibition entitled “Il Dolce Rumore Della Vita” (The Sweet Sound of Life).\n            "}</p>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/sculpture-in-the-cathedral.jpg"} alt={"“The Sweet Sound of Life” in Pietrasanta"} />
<figcaption>{"“The Sweet Sound of Life” in Pietrasanta"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                By that time, my search for a permanent home for “Mother and Child” had begun in earnest.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Not far from my studio in via Luna I had often visited “Il Museo Degli Innocenti” (the Museum of the Innocents) in Piazza della Santissima Annunziata in the heart of Florence.  I had been deeply touched by the story of the convent on which the Museum was based, which had been designed and build by Brunelleschi, who was also responsible for the magnificent Duomo nearby.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/the-silence-hidden-in-stone.jpg"} alt={"“The silence of a secret hidden in stone"} />
<figcaption>{"“The silence of a secret hidden in stone"}</figcaption>
</figure>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/museo-degli-innocenti.jpg"} alt={"Il Museo degli innocenti, Piazza Santissima Annunziata, Florence"} />
<figcaption>{"Il Museo degli innocenti, Piazza Santissima Annunziata, Florence"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                Il Museo degli innocenti, Piazza Santissima Annunziata, Florence\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<div class={"text"}>
<div>
<p>{"\n                During the exhibition in Pietrasanta I dared to hope that there might be a place in that remarkable story, in that wonderful Museo Degli Innocenti, for the marble “Mother and Child”\n            "}</p>
<p>{"\n                It was my dear friend Antonella Ierardi, whom I had known from her role as cultural director at Palazzo Medicci Riccardi during my “Di Cuore” Exhibition there in 2013, who had arranged for me to meet Dr Stefano Filipponi, director of Il Museo Degli Innocenti at the time.\n            "}</p>
<p>{"\n                From the time I first met Dr Filliponi in 2017 it was my wish to donate the marble sculpture of “Mother and Child” to the Museo Degli Innocent, but I never took for granted that such an important and historic institution would agree to accept it.  I was pleased to find however that there was a genuine willingness on their part.  However there were numerous obstacles to be overcome on the way, including structural issues, Covid, and location, before the arrangements could be finalised.\n            "}</p>
<p>{"\n                All this time the sculpture waited patiently in my store in Terrafino, Empoli, while one by one the issues were addressed and overcome. The donation was formally agreed in February 2022.\n            "}</p>
<p>{"\n                So it was that the 17 year odyssey came to an end, and my dream of a home in this beautiful museum was realised as the inauguration of “Mother and Child” was set to take place, on Thursday 16th June 2022.  My heart filled with joy and happiness, for my “Mother and Child” had found their home at last.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/mother&child/story/emily&coco-museo-innocenti.jpg"} alt={"Coco Blossom (17) and Emily Dawson share their happiness in 2022, as “Mother and Child “ arrives at Museo Degli Innocenti in Florence"} />
<figcaption>{"Coco Blossom (17) and Emily Dawson share their happiness in 2022, as “Mother and Child “ arrives at Museo Degli Innocenti in Florence"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                So it was that the 17 year odyssey came to an end, and my dream of a home in this beautiful museum was realised as the inauguration of “Mother and Child” was set to take place, on Thursday 16th June 2022.\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<div class={"text"}>
<div style={{"maxWidth":"80%","height":"20rem","display":"flex","alignItems":"center"}}>
<h2 style={{"textAlign":"center"}}>{"My heart filled with joy and happiness, for my"}<br />{"“Mother and Child” had found their home at last."}</h2>
</div>
</div>
</div>
</>;
}
